module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-WMWR223","includeInDevelopment":true,"dataLayerName":"datalayer","defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change"},
    }]
